import { toast } from 'sonner';

export function showSuccessNotification(message: string): void {
  toast.success(message);
}

export function showErrorNotification(message: string): void {
  toast.error(message);
}

export function showInformationNotification(message: string): void {
  toast.info(message);
}

interface NewNotificationToastOptions {
  title: string;
  body: string;
  actionLabel: string;
  onAction: () => void;
}

export function showNewNotificationToast(options: NewNotificationToastOptions): void {
  toast(options.title, {
    description: options.body,
    descriptionClassName: 'line-clamp-1',
    action: {
      label: options.actionLabel,
      onClick: options.onAction,
    },
  });
}

interface NewNotificationsSummaryToastOptions {
  message: string;
  actionLabel: string;
  onAction: () => void;
}

export function showNewNotificationsSummaryToast(
  options: NewNotificationsSummaryToastOptions
): void {
  toast(options.message, {
    action: {
      label: options.actionLabel,
      onClick: options.onAction,
    },
  });
}
